import React, {useState} from 'react'
import Card from './Card'
import { toURL } from '../util'
import { v4 } from 'uuid'
import { gtag } from 'ga-gtag'
import styles from './Deck.module.scss'

const formatCardName = (name) => {
  return name.split('//')[0].trim()
}

const sumCardCount = (cardArray) => {
  let count = 0
  cardArray.forEach((card) => {
    count += parseInt(card.cardcount)
  })

  return count
}

const Deck = ({value, title, site, archidekt_link}) => {
  console.log(archidekt_link)
  const deckList = JSON.stringify(value)
  const deckListArray = deckList.split("\\n")
  const categoryRE = /\[([A-zÀ-ž-\s\d']+)\]/g
  const cardLineRE = /\*?(\d+)\s([A-zÀ-ž\s'-\/]+)/u
  const cats = value.match(categoryRE)
  const firstCat = cats[0].replace("[", '').replace("]", '')
  const source = window.location.href.includes('commandersherald') ? 'ch' : 'edhrec'
  const post_path = new URL(window.location.href).pathname.split("/")
  const post_slug = post_path.pop() || post_path.pop()
  let deckObj = {}
  let latestCat = ""
  let numCards = 0
  let halfCats = 0
  let ck_out = ""
  let tcg_out = ""

  deckListArray.forEach((line, index) => {
    line = line.replace('"', '')
    if (cats.includes(line)) {
      const newline = line.replace('[', '').replace(']', '')
      deckObj[newline] = []
      latestCat = newline
    } else if(line.length > 3) {
      if (line.slice(0,2) !== "[/") {
        const cardParts = cardLineRE.exec(line)
        let card = {}
        if (!cardParts) {
          card.cardcount = 1
          card.cardname = line
        }
        else {
          card.cardcount = cardParts[1]
          card.cardname = cardParts[2]
        }
        deckObj[latestCat].push(card)
        numCards += 1
        ck_out += `%0D%0A${encodeURIComponent(`${card.cardcount} ${card.cardname}`)}`
        tcg_out += `%7C%7C${encodeURIComponent(`${card.cardcount} ${card.cardname}`)}`
      }
      else {
        if (numCards >= (deckListArray.length - (cats.length * 2)) / 2 && halfCats === 0)
          halfCats = Object.keys(deckObj).length
      }
    }
  })

  const ck_link = `https://www.cardkingdom.com/builder?c=${ck_out.slice(6)}&autofill_lp=1&std_only=0&NM=1&EX=1&VG=1&G=1&partner=edhreccontent&utm_source=edhrec&utm_medium=articles&utm_campaign=edhrec`
  const tcg_url = encodeURIComponent(`https://store.tcgplayer.com/massentry?partner=EDHREC&c=${tcg_out.slice(6)}&utm_campaign=affiliate&utm_medium=articles&utm_source=EDHREC`)
  const tcg_link = `https://partner.tcgplayer.com/c/4913290/1830156/21018?partnerpropertyid=5237567&subId1=articles&subId2=decklist&u=${tcg_url}`
  const ck_event_name = `${site}_deck_click_ck`
  const tcg_event_name = `${site}_deck_click_tcg`

  const rowOne = Object.entries(deckObj).slice(0, halfCats)
  const rowTwo = Object.entries(deckObj).slice(halfCats)

  const [currentImage, setCurrentImage] = useState(deckObj[firstCat][0].cardname)

  return (
    <>
      <div class={styles.deckContainer}>
        <hr />
        <div class={styles.headerContainer}>
          <h4>{title}</h4>
          <a onClick={gtag('event', 'archidekt_export_article_decklist', {title_slug: title})} 
            class={styles.archidektButton}
            href={archidekt_link ? archidekt_link : `https://archidekt.com/articles/${source}/${post_slug}/${toURL(title)}`}
            target="_blank"
            rel="noreferrer"
          >
            View on Archidekt
          </a>
        </div>
        <hr />
        <div class={styles.decklist}>
          <div class={styles.cards}>
          {[rowOne, rowTwo].map((row) => (
            <div class={styles.categoryGroups}>
              {row.map((arr) => {
                const key = arr[0]
                const val = arr[1]
                return (
                  <div>
                    <h4>{key} ({sumCardCount(val)})</h4>
                    <ul style={{"padding-left": "0px"}}>
                      {val.map((card) => {
                        return (
                          <li class={styles.listItem}>
                            <span>{card.cardcount} </span> 
                            <span onMouseOver={() => (setCurrentImage(card.cardname))}>
                              <a href="#" onClick={(event) => {event.preventDefault(); return false}}>{card.cardname}</a>
                            </span>
                          </li>
                        )
                      })}
                      </ul>
                  </div>
                )
              })}
            </div>
          ))}
          </div>
          <div class={styles.imageContainer}>
            <div class={styles.cardImage}>
              <Card
                key={v4()}
                name={currentImage}
                tag='deckPreview'
              />
            </div>
          </div>
        </div>
      </div>
      <div class={styles.buyBox}>
        <a 
          class="btn btn-primary mb-2" 
          onClick={gtag('event', 'click', {[ck_event_name]: ck_link})} 
          href={ck_link} 
          target="_blank" 
          rel="noreferrer"
        >
          Buy this decklist from Card Kingdom
        </a>
        <a
          class="btn btn-primary mb-2" 
          onClick={gtag('event', 'click', {[tcg_event_name]: tcg_link})} 
          href={tcg_link} 
          target="_blank" 
          rel="noreferrer"
        >
          Buy this decklist on TCGplayer
        </a>
      </div>
    </>
  )
}

export default Deck
